// Maps a course's `product` (from course.json) to its deep-link path within a
// Cribl.Cloud tenant workspace. Paths are appended to the workspace root URL
// (https://{ws}-{org}.{domain}). Live-tenant verification of these paths is
// tracked in DEMOS-546.
export const PRODUCT_DEEP_LINK_PATHS: Record<string, string> = {
  search: '/search',
  stream: '/stream/m/default',
  edge: '/edge/m/default_fleet/nodes',
  lake: '/lake',
};

// Returns a product-aware deep link into the tenant, or the tenant root unchanged
// when no product context is available or the product is unmapped.
export function productTenantUrl(tenantUrl: string, product?: string): string {
  if (!product) return tenantUrl;
  const path = PRODUCT_DEEP_LINK_PATHS[product.trim().toLowerCase()];
  if (!path) return tenantUrl;
  return `${tenantUrl.replace(/\/+$/, '')}${path}`;
}
